import React from "react";
import { View } from "../../../shared";

interface Props {
    data: any;
}

function PersonaAudienceView(props: Props) {
    const { data } = props;

    return (
        <div className="view-audience">
            <View
                title="View Persona Audience"
                viewData={[
                    { label: "Persona Name", key: "personaName" },
                    { label: "Application Name", key: "appName" },
                    { label: "Country", key: "country" },
                    { label: "Created At", key: "createdAt" },
                ]}
                data={data}
            />
            {data.audienceSpecialty.length > 0 && (
                <div>
                    <table className="table table-bordered table-sm mt-4">
                        <thead>
                            <tr>
                                <th scope="col" className="p-3">
                                    Audience Type
                                </th>
                                <th scope="col" className="p-3">
                                    Specialty Key
                                </th>
                                <th scope="col" className="p-3">
                                    Specialty Name
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.audienceSpecialty.map((item: any, index: number) => {
                                return (
                                    <tr key={index} className="pt-3">
                                        <td className="p-2">{item.audienceType}</td>
                                        <td className="p-2">{item.personaKey}</td>
                                        <td className="p-2">
                                            {item.personaText ? item.personaText : item.personaKey}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default PersonaAudienceView;
